"use strict";

import Vue from "vue";
import axios from "axios";

/**
 * Ofrece los métodos mismos métodos para acceder a datos independientemente del servidor a que acceda
 * Desacopla el código del framework y de la aplicaciones de cómo se acceden a los datos
 * @type {Object}
 */
const dataAccessOpencms = new Vue({
  // (se crea como componente Vue para que tenga acceso a toda la funcionalidad del framework,
  // p.e. $materialApp.utils, $log...)
  data: {
    config: {}
  },
  methods: {
    getUrlAsServerConfig(itemResourcePath) {
      var urlAsServerConfig = `${this.config.host}/${this.config.basePath}/${this.config.additionalPath}/${itemResourcePath}`;

      // Quitamos las barras que sobran (por si se han puesto de más)
      urlAsServerConfig = urlAsServerConfig.replace(/\/+/g, "/");
      urlAsServerConfig = urlAsServerConfig.replace(":/", "://");

      return urlAsServerConfig;
    },
    getCmsNotPageItemResourcePath(itemResourcePath) {
      return `${this.config.cmsResourcesNoPagesPath}/${itemResourcePath}${this.config.cmsResourcesNoPagesPathSuffix}`;
    },
    createItem(itemResourcePath, data) {
      // TODO: Cambiar y hacer que funcione esto con post, no se que pasa con opencms que no "pilla" los parametros post
      // (¿puede ser que no funcione desde localhot y si en producción?)
      // De momento lo hago por get pq parece que funciona

      return axios.get(
        this.getUrlAsServerConfig(
          this.getCmsNotPageItemResourcePath(itemResourcePath)
        ),
        { params: data }
      );
    },
    readCmsPageDataByRoutePath(routePath) {
      return this.readItemByResourcePath(
        `${routePath}?${this.config.cmsPageDataQueryParam}`
      );
    },
    readCmsRoutes() {
      return this.readItemByResourcePath(
        this.getCmsNotPageItemResourcePath(this.config.cmsResourceRoutes)
      );
    },
    readItemByResourcePath(itemResourcePath) {
      return axios.get(this.getUrlAsServerConfig(itemResourcePath));
    },
    readItemByFilterTerms(itemResourcePath, filterTerms) {
      var options = {
        paginationCurrentPage: 0,
        paginationResultsPerPage: 1,
        filterTerms: this.$mdApp.utils.cloneObject(filterTerms)
      };

      return this.readList(itemResourcePath, options);
    },
    readItemById(itemName, itemId) {
      return axios.get(this.getUrlAsServerConfig(itemName, itemId));
    },
    /**
     * [readList description]
     * @param  {[type]} itemName [description]
     * @param  {[type]} options  [description]
     * @return {[type]}          [description]
     */
    readList(itemName, options) {
      var aditionalRequestConfig = { params: {} };

      if (options) {
        if (options.paginationCurrentPage && options.paginationResultsPerPage) {
          // Añadimos los campos de paginacion y ordenacion
          var startPaginationIndex =
            (options.paginationCurrentPage - 1) *
            options.paginationResultsPerPage;

          aditionalRequestConfig = {
            params: {
              _start: startPaginationIndex,
              _limit: options.paginationResultsPerPage,
              _sort: options.sortFieldName,
              _order: options.sortOrder
            },
            responseType: "json"
          };
        }

        // Añadimos el campo de busqueda de texto completo si es que existe
        if (options.fullTextSearch) {
          aditionalRequestConfig.params.q = options.fullTextSearch;
        }

        // Añadimos las opciones de filtrado si es que se han pasado
        if (options.filterTerms) {
          var terms = options.filterTerms;

          // Recorremos los campos del objeto filter ({campo1: {op, valor}, campo2:... })
          for (var currentTermFieldName in terms) {
            if (
              terms[currentTermFieldName].op &&
              terms[currentTermFieldName].value
            ) {
              var currentTermValue = terms[currentTermFieldName].value;
              var newRequestParamName = "operator_not_defined";

              switch (terms[currentTermFieldName].op) {
                case "=":
                  newRequestParamName = currentTermFieldName;
                  break;
                case "~":
                  newRequestParamName = currentTermFieldName + "_like";
                  break;
                case "!=":
                  newRequestParamName = currentTermFieldName + "_ne";
                  break;
                case "<=":
                  newRequestParamName = currentTermFieldName + "_lte";
                  break;
                case ">=":
                  newRequestParamName = currentTermFieldName + "_gte";
                  break;
                default:
                  newRequestParamName = "operator_not_defined"; // Para que se vea el error en la url
                  // Vue.$log.error('Error en readList: operador ' + currentTermFieldName + 'indefinido para termino: ' + currentTermFieldName);
                  break;
              }

              aditionalRequestConfig.params[
                newRequestParamName
              ] = currentTermValue;
            } else if (terms[currentTermFieldName]) {
              // No viene con op y value, viene en fomra simple terms[currentTermFieldName] = value
              aditionalRequestConfig.params[currentTermFieldName] =
                terms[currentTermFieldName];
            }
          }
        }
      }

      var path = this.getUrlAsServerConfig(
        this.getCmsNotPageItemResourcePath(itemName)
      );

      // Vue.$log.debug('restDataAccess: readList: request url:', path);
      // Vue.$log.debug('restDataAccess: readList: request config:', aditionalRequestConfig);
      // // Vue.$log.debug('restDataAccess: readList: options:' + JSON.stringify(options));

      return axios.get(path, aditionalRequestConfig);
    },
    translateCmsUrl2RouterPath(cmsUrl) {
      return cmsUrl.replace(
        `${this.config.basePath}${this.config.additionalPath}`,
        ""
      );
    },
    translateCmsUrl2AbsoluteUrl(cmsUrl) {
      return `${this.config.host}${cmsUrl}`;
    }
  }
});

export default dataAccessOpencms;
